import styled from 'styled-components';

export const Map = styled.div`
  height: 60vh;
  z-index: 500;
  width: 100%;
`;
